module.exports = __webpack_public_path__ + "img/accelerator-3.9a6349c9.png";